// ...existing code...
import React from 'react';
import './LyrosWorkforce.css';
import { FaUsers, FaSearchDollar, FaChartLine, FaGraduationCap, FaHandshake } from 'react-icons/fa';
import { HiOutlineLightBulb } from 'react-icons/hi';
import { RiCustomerService2Fill } from 'react-icons/ri';
import { Link } from 'react-router-dom';
const SERVICES = [
  {
    icon: <FaUsers />,
    title: 'Workforce Planning & Forecasting',
    text: 'Align staffing with demand using data-driven forecasts, capacity planning and skills mapping.',
  },
  {
    icon: <FaSearchDollar />,
    title: 'Talent Acquisition & Recruitment',
    text: 'Targeted sourcing, automated screening and competency assessments to hire the right talent faster.',
  },
  {
    icon: <FaChartLine />,
    title: 'Performance Management',
    text: 'Continuous feedback, goal alignment and measurable performance programs to grow high performers.',
  },
  {
    icon: <FaGraduationCap />,
    title: 'Learning & Development',
    text: 'Role-based learning paths, micro-training and upskilling programs to close critical skill gaps.',
  },
  {
    icon: <HiOutlineLightBulb />,
    title: 'Change & Adoption',
    text: 'Organizational change, communication and adoption playbooks to ensure new processes stick.',
  },
  {
    icon: <FaHandshake />,
    title: 'Retention & EVP',
    text: 'Employee value proposition, career frameworks and retention analytics to keep your best people.',
  },
];

const WHY = [
  { icon: <FaChartLine />, title: 'Data-driven outcomes', text: 'Insights tied to KPIs and business impact.' },
  { icon: <FaUsers />, title: 'People-first design', text: 'Solutions that respect employee experience.' },
  { icon: <RiCustomerService2Fill />, title: 'End-to-end support', text: 'Advisory, implementation and managed services.' },
];

const WorkforceManagement = () => {
  return (
    <div className="lyros-container">
      <header className="lyros-header">
        <div className="header-content">
          
          <h1>WORKFORCE MANAGEMENT</h1>
          <p className="subtitle">
            Transform human potential into organizational performance — optimize staffing, skills and retention with Lyros.
          </p>

          <div className="header-ctas">
            <Link
          to="/contact" // ✅ Navigate to Contact page
          className="btn-primary"
          aria-label="Contact Lyros"
        >
          Talk to our Expert team
        </Link>
          </div>
        </div>

        <svg className="header-decor" viewBox="0 0 800 200" preserveAspectRatio="none" aria-hidden="true">
          <defs>
            <linearGradient id="gA" x1="0" x2="1">
              <stop offset="0" stopColor="#0ea5e9" stopOpacity="0.14" />
              <stop offset="1" stopColor="#6366f1" stopOpacity="0.06" />
            </linearGradient>
          </defs>
          <path d="M0 140 C160 40 360 240 800 80 L800 200 L0 200 Z" fill="url(#gA)"></path>
        </svg>
      </header>

      <main className="lyros-main">
        <section className="intro-section card reveal-up">
          <div className="intro-grid">
            <div>
              <h2>Why modern workforce management matters</h2>
              <p>
                Organizations that plan talent strategically reduce operational risk, improve productivity and scale faster.
                Lyros delivers practical WFM solutions — from forecasting and hiring to L&D, performance and retention.
              </p>
            </div>

            <div className="kpi-cards">
              <div className="kpi">
                <strong>30%</strong>
                <span>Time-to-hire reduction</span>
              </div>
              <div className="kpi">
                <strong>25%</strong>
                <span>Improvement in productivity</span>
              </div>
              <div className="kpi">
                <strong>75%</strong>
                <span>Faster role onboarding</span>
              </div>
              
            </div>
          </div>
        </section>

        <section className="services-section">
          <h3 className="section-title">Our Services</h3>
          <div className="services-grid">
            {SERVICES.map((s, i) => (
              <article className="service-card reveal-up" key={i} aria-labelledby={`svc-${i}-title`}>
                <div className="service-icon" aria-hidden>
                  {s.icon}
                </div>
                <div className="service-body">
                  <h4 id={`svc-${i}-title`}>{s.title}</h4>
                  <p>{s.text}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section className="examples-section">
          <h3 className="section-title">Our Approach</h3>
          <div className="examples-grid">
            <article className="example-card reveal-up">
              <h4>Global RPO & Hiring Acceleration</h4>
              <p>Implemented global recruitment program, reducing hiring time and cost while improving candidate quality.</p>
            </article>
            <article className="example-card reveal-up">
              <h4>Skills Taxonomy & L&D Program</h4>
              <p>Built role taxonomies and learning paths to upskill workforce for digital transformation initiatives.</p>
            </article>
            <article className="example-card reveal-up">
              <h4>Performance & Career Framework</h4>
              <p>Designed performance frameworks and career ladders to increase engagement and internal mobility.</p>
            </article>
          </div>
        </section>

        <section className="why-section">
          <h3 className="section-title">Why choose Lyros</h3>
          <div className="why-grid">
            {WHY.map((w, i) => (
              <div className="why-card reveal-up" key={i}>
                <div className="why-icon" aria-hidden>{w.icon}</div>
                <div>
                  <h4>{w.title}</h4>
                  <p>{w.text}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="cta-section reveal-up">
          <div className="cta-card">
            <div>
              <h3>Ready to transform your workforce?</h3>
              <p>Contact Lyros to design a people strategy that powers business outcomes.</p>
            </div>
            <div className="cta-actions">
             <Link
          to="/contact" // ✅ Navigate to Contact page
          className="btn-primary"
          aria-label="Contact Lyros"
        >
        Get Started
        </Link> </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default WorkforceManagement;
// ...existing code...